import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { toggleSignupModal } from '../../actions/generic-globals.actions';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'office-ui-fabric-react';
import { Button } from 'primereact/button';
import { countries, jobTitles, preferredUnitOptions } from './signup.constant';
import MiniCADAPI from '../../lib/MiniCADAPI';
import { getUserGeolocationLog, saveUserAgreementLog } from '../../lib/agreement-log';
import { saveUserLocalizationDefaults } from '../../lib/localization/regions';
import { updateUserData } from '../../actions/authentication-actions';
import { setActiveRegion, setSystemUnit } from '../../actions/localization-actions';
import './signup.css'

const defaultState = {
  givenName: '',
  surname: '',
  mobilePhone: '',
  companyName: '',
  country: '',
  state: null,
  city: '',
  postalCode: '',
  county: '',
  preferredUnits: null,
  jobTitle: null,
  agreed: false,
  mailingList: true,
  errors: {},
  hidden: true,
  submitting: false,
};

let requiredFields = [
  'givenName',
  'surname',
  'mobilePhone',
  'companyName',
  'country',
  'city',
  'postalCode',
  'jobTitle',
];

class signupModal extends PureComponent {
  state = defaultState;
  states = [];
  counties_regions = [];
  selectedCountry;

  componentDidUpdate(prevState) {
    if (this.props.user !== prevState.user) {
      if (this.props.user) {
        if (!this.hasUpdatedB2CData()) {
          this.setState({ hidden: false });
          this.props.toggleSignupModal(true);
        }
      }
    }
  }

  closeModal = () => {
    this.setState({ ...defaultState });
    this.props.toggleSignupModal(false);
  };

  handleInputChange = (value, field) => {
    let constrain;
    let errorMessage;
    this.setState({
      [field]: value,
    });
    switch (field) {
      case 'givenName':
        constrain = /^[\w\W]{1,}$/;
        errorMessage = this.props.content[this.props.lang].givenNameError;
        break;
      case 'surname':
        constrain = /^[\w\W]{1,}$/;
        errorMessage = this.props.content[this.props.lang].surnameError;
        break;
      case 'companyName':
        constrain = /^[\w\W]{1,}$/;
        errorMessage = this.props.content[this.props.lang].companyInputError;
        break;
      case 'postalCode':
        constrain = this.state.country === 'Canada' ? /^[A-Za-z]\d[A-Za-z] \d[A-Za-z]\d$/ : /^\d{5}(?:-\d{4})?$/;
        errorMessage = !this.state.country
          ? this.props.content[this.props.lang].zipcodeInputError
          : this.state.country === 'Canada'
          ? this.props.content[this.props.lang].canadianZipcodeInputError
          : this.props.content[this.props.lang].USZipcodeInputError;
        break;
      default:
        constrain = /^[a-zA-Z\s]{1,}$/;
        errorMessage = `${this.props.content[this.props.lang].defaultInputError} ${field}.`;
        break;
    }

    if (!constrain.test(value)) {
      this.setState((prevState) => ({
        errors: {
          ...prevState.errors,
          [field]: errorMessage,
        },
      }));
    } else {
      this.setState((prevState) => ({
        errors: {
          ...prevState.errors,
          [field]: '',
        },
      }));
    }
  };

  handleCountryChange = (countryName) => {
    const foundCountry = countries.find((country) => country.name === countryName);
    this.states = foundCountry ? foundCountry.states || null : null;
    this.counties_regions = null;
    this.selectedCountry = foundCountry;
    this.setState({
      country: countryName,
      state: null,
      county: '',
    });
    setTimeout(() => {
      this.handleInputChange(this.state.postalCode, 'postalCode');
    });
  };

  handleStatesChange = (stateName) => {
    const foundState = this.states && this.states.length ? this.states.find((state) => state.name === stateName) : null;
    this.counties_regions = foundState ? foundState.counties || null : null;
    this.setState({
      state: stateName,
      county: '',
    });
  };

  hasErrorsOrNotAgreed = () => {
    let requiredPardotFields = [];
    switch (this.state.country) {
      case 'United States':
        requiredPardotFields = requiredFields.concat(['state', 'county', 'preferredUnits']);
        break;
      case 'Canada':
        requiredPardotFields =
          this.state.state === 'British Columbia' || this.state.state === 'Ontario' || this.state.state === 'Quebec'
            ? requiredFields.concat(['state', 'county', 'preferredUnits'])
            : requiredFields.concat(['state', 'preferredUnits']);
        break;
      default:
        requiredPardotFields = requiredFields.concat(['preferredUnits']);
        break;
    }
    const allFieldsFilled = requiredPardotFields.every((field) => this.state[field]);

    return !allFieldsFilled || Object.values(this.state.errors).some((error) => error !== '') || !this.state.agreed;
  };

  hasUpdatedB2CData = () => {
    const { b2cData } = this.props;
    if (b2cData) {
      let fieldsToCheck = requiredFields;
      let newValues = {};
      let hasAllRequiredFields = true;
      switch (b2cData.country) {
        case 'United States':
          fieldsToCheck = requiredFields.concat(['state', 'county', 'preferredUnits']);

          break;
        case 'Canada':
          fieldsToCheck =
            this.state.state === 'British Columbia' || this.state.state === 'Ontario' || this.state.state === 'Quebec'
              ? requiredFields.concat(['state', 'county', 'preferredUnits'])
              : requiredFields.concat(['state', 'preferredUnits']);

          break;
        default:
          fieldsToCheck = requiredFields.concat(['preferredUnits']);
          break;
      }
      fieldsToCheck.forEach((field) => {
        let isFilled = false;
        if (field !== 'preferredUnits' && field !== 'county') {
          isFilled = Boolean(b2cData[field]);
        } else {
          isFilled = field !== 'preferredUnits' ? Boolean(this.props.user[field]) : !!this.props.preferredUnits;
        }
        if (isFilled) {
          if (field !== 'preferredUnits' && field !== 'county') {
            newValues[field] = b2cData[field];
          } else {
            newValues[field] = field !== 'preferredUnits' ? this.props.user[field] : null;
          }
          switch (field) {
            case 'country':
              this.handleCountryChange(b2cData[field]);
              break;
            case 'state':
              this.handleStatesChange(b2cData[field]);
              break;
            default:
              this.setState(newValues);
          }
        } else {
          hasAllRequiredFields = false;
        }
      });
      // Only return true if all fields are filled and some fields changed
      return hasAllRequiredFields;
    }
    return false;
  };

  signUp = async () => {
    const b2cData = {
      displayName: `${this.state.givenName} ${this.state.surname}`,
      givenName: this.state.givenName,
      surname: this.state.surname,
      mobilePhone: this.state.mobilePhone,
      companyName: this.state.companyName,
      country: this.state.country,
      state: this.state.state,
      city: this.state.city,
      postalCode: this.state.postalCode,
      jobTitle: this.state.jobTitle,
    };
    this.setState({ submitting: true });
    try {
      await saveUserLocalizationDefaults(
        this.props.user.id,
        this.props.region.id,
        this.props.language.id,
        this.state.preferredUnits,
        this.props.resourcesTokens.users.tableToken,
        this.state.county,
        this.state.mailingList,
      );
      await MiniCADAPI.updateB2CUser(this.props.resourcesTokens.users.adToken, this.props.userId.uniqueId, b2cData);

      /*await MiniCADAPI.sendProxyData(
        this.formatPayload(),
        `https://${process.env.REACT_APP_API_URL}/api/automationpardotproxy`,
      );*/

      this.props.updateUserData({
        state: this.state.state,
        county: this.state.county,
        mailingList: this.state.mailingList,
        jobTitle: this.state.jobTitle,
        country: this.state.country,
        b2cData: b2cData,
      });

      this.saveUserProfileToLocalStorage({
        companyName: this.state.companyName,
        givenName: this.state.givenName,
        mobilePhone: this.state.mobilePhone,
        state: this.state.state,
        surname: this.state.surname,
        country: this.state.country,
      });
    } catch (error) {
      console.error(error);
    }
    this.setState({ submitting: false });
    this.closeModal();
  };

  saveUserProfileToLocalStorage(userProfile) {
    localStorage.setItem('userProfile', JSON.stringify(userProfile));
  }

  formatPayload() {
    const data = {
      firstName: this.state.givenName,
      lastName: this.state.surname,
      company: this.state.companyName,
      email: this.props.user.mail,
      country: this.state.country,
      state: this.state.state,
      mailingList: `${this.state.mailingList}`,
      comments: '',
      designTool: 'Cultec Design Tool',
      customerType: this.state.jobTitle !== 'Cultec Employee' ? this.state.jobTitle : undefined,
      phone: this.state.mobilePhone,
      companyBrand: 'ADS',
      utm_campaign: '',
      utm_content: '',
      utm_medium: '',
      utm_source: '',
      utm_term: '',
      utm_id: '',
    };

    switch (this.state.country) {
      case 'United States':
        data.county = this.state.county;
        break;
      case 'Canada':
        data.canadaRegion = this.state.county;
        break;
      default:
        break;
    }
    return data;
  }

  handleAgreed = async () => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();

    if (localStorage.getItem(`agreedToTerms`)) {
      localStorage.removeItem(`agreedToTerms`);
    }

    for (let i = 0; i < 12; i++) {
      if (localStorage.getItem(`agreedToTerms${i}`)) {
        localStorage.removeItem(`agreedToTerms${i}`);
      }
    }

    localStorage.setItem(`agreedToTerms${currentMonth}`, true);
    this.setState({ hidden: true });

    if (this.props.user) {
      const { givenName, surname, mail, id, mobilePhone } = this.props.user;
      const { agreementLogToken } = this.props.resourcesTokens;
      const geo = await getUserGeolocationLog();
      const agreementPayload = {
        userId: id,
        agreementTimestamp: new Date(),
        IPAddress: geo.IPv4,
        country_name: geo.country_name,
        latitude: geo.latitude,
        longitude: geo.longitude,
        state: geo.state,
        city: geo.city,
        userEmail: mail,
        mobilePhone,
        fullName: `${surname} ${givenName}`,
        givenName,
        surname,
      };
      console.log('agreementPayload, agreementLogToken.tableToken',agreementPayload, agreementLogToken.tableToken)
      saveUserAgreementLog(agreementPayload, agreementLogToken.tableToken).then(
        (result) => {
          if (result) {
            console.info({ result });
          }
        },
        (err) => {
          console.log(`Failed to update users default localization data: ${err.message}`);
        },
      );
    }
  };

  render() {
    const { lang, content, showSignUpModal } = this.props;

    const { city, preferredUnits } = this.state;

    const formContainerStyle = {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
      padding: '0 2rem',
    };
    const flexRowStyle = {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '1rem',
      height: '3.5rem',
    };
    const inputRowStyle = {
      display: 'flex',
      flexDirection: 'column',
      width: '50%',
    };
    const inputStyle = {
      width: '100%',
      height: '100%',
    };
    const footerStyle = {
      display: 'flex',
      padding: '0 2rem',
      marginTop: '2rem',
    };

    const checkBoxContainerStyle = {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '0.5rem',
      flex: 1,
    };

    const buttonContainerStyle = {
      display: 'flex',
      alignItems: 'center',
    };

    return (
      <Dialog
        header={content[lang].signUp}
        visible={showSignUpModal}
        style={{ width: '50vw' }}
        onHide={() => this.closeModal()}
        closable={false}>
        <div id="signupForm" style={formContainerStyle}>
          <div style={flexRowStyle}>
            <div style={inputRowStyle}>
              <InputText
                style={inputStyle}
                value={this.state.givenName}
                onChange={(e) => this.handleInputChange(e.target.value, 'givenName')}
                className="required-input"
                placeholder={`${content[lang].firstName} *`}
                required={true}
              />
              {this.state.errors.givenName && (
                <div>
                  <small style={{ color: 'red' }}>{this.state.errors.givenName}</small>
                </div>
              )}
            </div>

            <div style={inputRowStyle}>
              <InputText
                style={inputStyle}
                value={this.state.surname}
                onChange={(e) => this.handleInputChange(e.target.value, 'surname')}
                className="required-input"
                placeholder={`${content[lang].lastName} *`}
                required={true}
              />
              {this.state.errors.surname && (
                <div>
                  <small style={{ color: 'red' }}>{this.state.errors.surname}</small>
                </div>
              )}
            </div>
          </div>
          <div style={flexRowStyle}>
            <InputMask
              style={{ ...inputStyle, width: '50%' }}
              value={this.state.mobilePhone}
              onChange={(e) =>
                this.setState({
                  mobilePhone: e.value,
                })
              }
              mask="(999) 999-9999"
              className="required-input"
              placeholder={`${content[lang].phoneNumber} *`}
              required={true}
            />
            <div style={inputRowStyle}>
              <InputText
                style={inputStyle}
                value={this.state.companyName}
                onChange={(e) => this.handleInputChange(e.target.value, 'companyName')}
                className="required-input"
                placeholder={`${content[lang].companyName} *`}
                required={true}
              />
              {this.state.errors.companyName && (
                <div>
                  <small style={{ color: 'red' }}>{this.state.errors.companyName}</small>
                </div>
              )}
            </div>
          </div>
          <Dropdown
            style={{ height: '3.5rem' }}
            value={this.state.country}
            onChange={(e) => this.handleCountryChange(e.value)}
            options={countries}
            optionLabel="name"
            optionValue="name"
            className="required-input"
            placeholder={`${content[lang].country} *`}
            required={true}
          />

          {!!this.states && !!this.states.length && (
            <div style={flexRowStyle}>
              <Dropdown
                style={{ ...inputStyle, width: '50%' }}
                value={this.state.state}
                onChange={(e) => this.handleStatesChange(e.value)}
                options={this.states}
                optionLabel="name"
                optionValue="name"

                className="required-input"
                placeholder={`${this.selectedCountry.code !== 'CA' ? content[lang].state : content[lang].province} *`}
                required={true}
              />

              <Dropdown
                style={{ ...inputStyle, width: '50%' }}
                value={this.state.county}
                onChange={(e) => this.setState({ county: e.value })}
                options={this.counties_regions}
                optionLabel="name"
                optionValue="name"
                disabled={!this.counties_regions || !this.counties_regions.length}

                className="required-input"
                placeholder={`${this.selectedCountry.code !== 'CA' ? content[lang].county : content[lang].region} *`}
                required={true}
              />
            </div>
          )}
          <div style={flexRowStyle}>
            <div style={inputRowStyle}>
              <InputText
                style={inputStyle}
                value={city}
                onChange={(e) => this.handleInputChange(e.target.value, 'city')}

                className="required-input"
                placeholder={`${content[lang].city} *`}
                required={true}
              />
              {this.state.errors.city && (
                <div>
                  <small style={{ color: 'red' }}>{this.state.errors.city}</small>
                </div>
              )}
            </div>

            <div style={inputRowStyle}>
              <InputText
                style={inputStyle}
                value={this.state.postalCode}
                onChange={(e) => this.handleInputChange(e.target.value, 'postalCode')}

                className="required-input"
                placeholder={`${content[lang].zipCode} *`}
                required={true}
              />
              {this.state.errors.postalCode && (
                <div>
                  <small style={{ color: 'red' }}>{this.state.errors.postalCode}</small>
                </div>
              )}
            </div>
          </div>
          <Dropdown
            style={{ height: '3.5rem' }}
            value={preferredUnits}
            onChange={(e) => this.setState({ preferredUnits: e.value })}
            options={preferredUnitOptions}
            optionLabel="name"
            optionValue="code"
            className="required-input"
            placeholder={`${content[lang].selectYourPreferredUnits} *`}
            required={true}
          />
          <Dropdown
            style={{ height: '3.5rem' }}
            value={this.state.jobTitle}
            onChange={(e) => this.setState({ jobTitle: e.value })}
            options={jobTitles}
            className="required-input"
            placeholder={`${content[lang].whatisYourRole} *`}
            required={true}
          />

          <div
            style={{
              ...flexRowStyle,
              fontWeight: 'bold',
              height: '1rem'
            }}>
            {content[lang].agreementTitle}
          </div>

          <div
            /*style={{
              // ...flexRowStyle,
              height: '5rem',
              overflowY: 'scroll',
              //overflowX: 'scroll', // Enable horizontal scrollbar
              width: '90%',
              minWidth: '90%',
              border: '1px solid red'
            }}*/
          className={'sign-up-scrollbar'}
          >

            {content[lang].agreenmentText}
          </div>
        </div>
        <div id="signupFooter" style={footerStyle}>
          <div style={{ ...flexRowStyle, width: '100%' }}>
            <div style={checkBoxContainerStyle}>
              {/* <Checkbox
                label={content[lang].keepMeUpToDate}
                checked={this.state.mailingList}
                onChange={(evt, checked) => {
                  evt.preventDefault();
                  this.setState({ mailingList: checked });
                }}
              />*/}
              <Checkbox
                label={content[lang].agreedToTerms}
                onChange={(evt, checked) => {
                  evt.preventDefault();
                  this.setState({ agreed: checked });
                }}
              />
            </div>
            <div style={buttonContainerStyle}>
              <Button
                label={content[lang].signUp}
                className="p-button-success"
                disabled={this.state.submitting || this.hasErrorsOrNotAgreed()}
                style={{ marginLeft: '10px' }}
                onClick={() => {
                  this.handleAgreed();
                  this.signUp();
                }}
              />
            </div>
          </div>
        </div>
      </Dialog>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.localization.lang,
    content: state.localization.content,
    showSignUpModal: state.globals.showSignUpModal,
    resourcesTokens: state.authentication.resourcesTokens,
    userId: state.authentication.accessToken,
    user: state.authentication.user,
    b2cData: state.authentication.b2cData,
    language: state.localization.language,
    region: state.localization.region,
    preferredUnits: state.localization.unit,
  };
};

const mapDispatchToProps = {
  toggleSignupModal,
  getUserGeolocationLog,
  saveUserAgreementLog,
  updateUserData,
  setSystemUnit,
  setActiveRegion,
};

export default connect(mapStateToProps, mapDispatchToProps)(signupModal);



// WEBPACK FOOTER //
// ./src/components/SignUp/signup.component.js